import type { SVGProps } from 'react';

import * as styles from './LegacySearchIcon.css';

export const LegacySearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.spyglassIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M14.3,13.3c0.1,0.1,0.2,0.2,0.2,0.3s0,0.3-0.1,0.4c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0
		c-0.1,0-0.1-0.1-0.2-0.1l-3.6-3.2c-0.2,0.2-0.5,0.4-0.7,0.6c-0.3,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.7,0.3-1.1,0.3s-0.8,0.1-1.1,0.1
		c-0.4,0-0.8,0-1.1-0.1s-0.7-0.2-1.1-0.3c-0.3-0.1-0.7-0.3-1-0.5s-0.6-0.4-0.8-0.7C2,10.3,1.8,10,1.6,9.7c-0.2-0.3-0.4-0.6-0.5-1
		C0.9,8.4,0.8,8,0.7,7.7C0.7,7.3,0.6,6.9,0.6,6.5c0-0.4,0-0.8,0.1-1.1C0.8,5,0.9,4.7,1.1,4.3c0.1-0.3,0.3-0.7,0.5-1
		C1.8,3.1,2,2.8,2.3,2.5C2.6,2.2,2.8,2,3.1,1.8c0.3-0.2,0.6-0.4,1-0.5C4.5,1.1,4.8,1,5.2,0.9s0.7-0.1,1.1-0.1c0.4,0,0.8,0,1.1,0.1
		s0.7,0.2,1.1,0.3c0.3,0.1,0.7,0.3,1,0.5c0.3,0.2,0.6,0.4,0.8,0.7c0.3,0.3,0.5,0.6,0.7,0.8c0.2,0.3,0.4,0.6,0.5,1
		c0.1,0.4,0.3,0.7,0.3,1.1S12,6.1,12,6.5c0,0.4,0,0.8-0.1,1.1c-0.1,0.4-0.2,0.7-0.3,1.1c-0.1,0.2-0.2,0.5-0.3,0.7
		c-0.1,0.2-0.3,0.4-0.4,0.6L14.3,13.3z M6.3,11.2c0.6,0,1.2-0.1,1.8-0.4c0.6-0.2,1.1-0.6,1.5-1c0.5-0.4,0.8-0.9,1-1.5
		C10.9,7.8,11,7.2,11,6.5s-0.1-1.2-0.4-1.8c-0.2-0.6-0.6-1.1-1-1.5c-0.4-0.4-1-0.8-1.5-1C7.5,1.9,6.9,1.8,6.3,1.8S5.1,1.9,4.5,2.2
		C3.9,2.4,3.4,2.8,3,3.2c-0.4,0.5-0.8,1-1,1.5S1.6,5.9,1.6,6.5S1.7,7.8,2,8.3s0.6,1.1,1,1.5c0.4,0.4,0.9,0.8,1.5,1
		C5.1,11.1,5.7,11.2,6.3,11.2z"
    />
  </svg>
);
